module.exports = __webpack_public_path__ + "img/tech6small.930b4081.jpg";